
// ROUTES
require('modules/invitation-list/routes/invitation-list');


// CONTROLLERS
require('modules/invitation-list/controllers/invitation-list');
require('modules/invitation-list/controllers/list');
require('modules/invitation-list/controllers/create');
require('modules/invitation-list/controllers/edit');
require('modules/invitation-list/controllers/comunicate');
require('modules/invitation-list/controllers/comunicate-dem');
require('modules/invitation-list/controllers/comunicate-dem-confirmation');
require('modules/invitation-list/controllers/comunicate-dem-declined');
require('modules/invitation-list/controllers/comunicate-badge');
require('modules/invitation-list/controllers/comunicate-ics');
require('modules/invitation-list/controllers/comunicate-dem-al-zm');
require('modules/invitation-list/controllers/comunicate-dem-al-am');
require('modules/invitation-list/controllers/comunicate-dem-al-zm-confirmation');
require('modules/invitation-list/controllers/comunicate-gp');
require('modules/invitation-list/controllers/comunicate-gp-preinvitation');
require('modules/invitation-list/controllers/comunicate-gp-approved');
require('modules/invitation-list/controllers/comunicate-gp-declined');


// SERVICES
require('modules/invitation-list/services/invitation-list');
require('modules/invitation-list/services/list');
require('modules/invitation-list/services/create');
require('modules/invitation-list/services/edit');
require('modules/invitation-list/services/delete');
require('modules/invitation-list/services/comunicate');
require('modules/invitation-list/services/comunicate-gp');



angular.module('unica_invitation_list', [

	// ROUTES
	'unica_invitation_list.invitation_list_routes',

	// CONTROLLERS
	'unica_invitation_list.invitation_list_controllers',

	// SERVICES
	'unica_invitation_list.invitation_list_services'

]);